import { PlayerData } from './../Models/ApplicationInterfaces';
import { Vector4 } from './../Models/MapInterfaces';
export const playerColorList = [
    "#EB4A4A",
    "#00A3FF",
    "#F26430",
    "#6761A8",
    "#EBDB4A",
    "#9EFF00",
];
export const playerIconList = [
    "Anon",
    "ClassicSpy",
    "Ninja",
    "Smith",
    "Halberd",
    "ShasO"
];
export function generatePlayerData():PlayerData {
    const namesList = [
        "Metro",
        "Slyvain",
        "Reaper",
        "Ghost",
        "Santa Cruz",
        "Salamander",
        "Shadow",
        "Trenchcoat",
        "Raptor",
        "47",
        "Scarecrow"
    ];
    
    return {
        color: playerColorList[Math.floor(Math.random() * playerColorList.length)],
        icon: Math.floor(Math.random() * (playerIconList.length - 2)),
        index: -1,
        name: namesList[Math.floor(Math.random() * namesList.length)],
    }
}

export function getPlayerIcon(index: number) {
    return "/PlayerIcons/"+playerIconList[index]+".png";
}
export const rgbToHex = (rgb:number) => { 
    console.log(rgb * 255);
    let hex = Math.floor(Number(rgb * 255)).toString(16);
    if (hex.length < 2) {
         hex = "0" + hex;
    }
    console.log(hex);
    return hex;
};
export const colorVectorToHex = (col:Vector4) :string => {
    console.log(col, rgbToHex(col.x) + rgbToHex(col.y) + rgbToHex(col.z) )
    return "#"+rgbToHex(col.x) + rgbToHex(col.y  ) + rgbToHex(col.z ) 
}
export function parsePlayer(data:{id: number, name: string, color:Vector4,icon:number}): PlayerData {
    const {name, id, color, icon} = data;
    return {name, index: id, color:colorVectorToHex(color), icon};
}



// WEBPACK FOOTER //
// ./src/utility/PlayerDataGenerator.ts